export default "__VITE_ASSET__DUguzrWa__"